import React, { useMemo } from "react";
import TrashCanOutline from "mdi-material-ui/TrashCanOutline";
import moment from "moment-timezone";

const getFirstAndLastName = (name) => {
  let _name = name;
  try {
    if (!name.includes(" ")) return _name;

    let tmpArray = name.split(" ");

    const firstname = tmpArray[0];
    const lastname = tmpArray.pop();
    if (firstname !== "" && lastname !== "") {
      _name = firstname + " " + lastname;
      return _name;
    }
  } catch (err) {
    return _name;
  }
};

const CommentDate = ({ comment }) => {
  if (moment.utc(comment.date).isAfter(moment.utc())) return <small>Agora</small>;
  return <small>{moment.utc(comment.date).fromNow()}</small>;
};

const CommentInfo = ({ auth, comment, setDeleteCommentModal }) => {
  const isSelfComment = comment?.user_id === auth.user.user_id;

  const MemoCommentInfo = useMemo(
    () => (
      <div className="comment-content">
        <div className="comment-head">
          <span className="comment-author">{getFirstAndLastName(comment?.user?.name)}</span>
          <span className="comment-meta">
            <CommentDate comment={comment} />
          </span>
          {comment?.is_producer === true && <span className="comment-badge comment-badge--author">Autor</span>}
          {/* {comment?.status === "rejected" && <span className="comment-badge comment-badge--rejected">Comentário rejeitado</span>} */}
          {comment?.status === "pending" && <span className="comment-badge comment-badge--pending">Aguarda aprovação</span>}
          {isSelfComment && (comment?.replies?.length === 0 || comment?.is_reply === true) && (
            <button
              type="button"
              className="comment-delete"
              aria-label="Apagar comentário"
              title="Apagar comentário"
              onClick={() => setDeleteCommentModal({ visible: true, id: comment._id })}
            >
              <TrashCanOutline />
            </button>
          )}
        </div>
        <p className="comment-body">{comment?.commentText}</p>
      </div>
    ),
    [comment, setDeleteCommentModal, isSelfComment]
  );

  return MemoCommentInfo;
};

export default CommentInfo;
